
import JSON5 from 'json5';
import _ from 'lodash';

export default class BaseApi {
    static getConfig() {
        return new Promise(resolve => {
            fetch(`${process.env.PUBLIC_URL}/config/app.json`).then(resp => {
                return resp.text()
            }).then(resp => {
                const r = JSON5.parse(resp)

                resolve(r)
            })
        })
    }
}